import { get } from 'lodash';
import { computed } from 'vue';
import { useNovaCore, useSettings, useOrg } from '@/composables';
import { useI18n } from 'vue-i18n';

/**
 * @param {Object} event
 * @param {string} event.createDateTime
 * @returns {{formattedDateTime: string}}
 */
export default function useAssetVisitEvent(event, timezone) {
  const { locale } = useI18n();
  const novaCore = useNovaCore();
  const { settingsGettersRef } = useSettings();
  const org = useOrg();

  const formattedDateTime = computed(() => {
    const createDateTime = get(event, 'createDateTime') || '';

    if (!createDateTime || !timezone) {
      return '';
    }

    try {
      return novaCore.formatDateTimeWithMilitarySupport(
        createDateTime,
        timezone,
        novaCore.LuxonDateTimeFormats.Extended12HrTimeAMPM,
        settingsGettersRef.value.isMilitaryTimeEnabled(org),
        novaCore.LuxonDateTimeFormats.Extended24HrTimeNoPadding,
        locale.value
      );
    } catch (error) {
      console.error('Error formatting date time', error);
      return '';
    }
  });

  const eventType = computed(() => {
    // TODO: Translate this after it's finished
    return get(event, 'eventType') || 'NA';
  });

  return {
    formattedDateTime,
    eventType
  };
}
